import NewsApi from "./news-api";

export const newsApi = new NewsApi();
